import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=78b61122&scoped=true"
import script from "./OrderInfo.vue?vue&type=script&lang=ts"
export * from "./OrderInfo.vue?vue&type=script&lang=ts"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=78b61122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b61122",
  null
  
)

export default component.exports